import { useMemo } from 'react'
import {
  MenuItem,
  FormGroup,
  Tooltip,
  FormControlLabel,
  Switch,
  Stack,
  Box,
  useTheme,
} from '@mui/material'

interface Props {
  checked: boolean
  setChecked: (checked: boolean) => void
  tooltipTitle: string
  menuItemLabel: string
  matureness: 'mature' | 'experimental' | 'discouraged' | 'enabled'
  dataCy?: string
  disabled?: boolean
}

const MenuToggleWithMatureness = ({
  checked,
  setChecked,
  tooltipTitle,
  menuItemLabel,
  matureness,
  dataCy,
  disabled = false,
}: Props) => {
  const theme = useTheme()

  const maturenessTitle = useMemo(() => {
    switch (matureness) {
      case 'mature':
        return '(ausgereift)'
      case 'experimental':
        return '(experimentell)'
      case 'discouraged':
        return '(nicht empfohlen)'
      case 'enabled':
        return ''
      default:
        return ''
    }
  }, [matureness])

  const backgroundColor = useMemo(() => {
    switch (matureness) {
      case 'mature':
        return theme.palette.success.main
      case 'experimental':
        return theme.palette.warning.main
      case 'discouraged':
        return theme.palette.error.main
    }
  }, [matureness, theme])

  return (
    <MenuItem>
      <FormGroup>
        <Tooltip title={`${tooltipTitle} ${maturenessTitle}`} placement="left">
          {/* span so the tooltip still fires when the switch is disabled */}
          <span>
            <FormControlLabel
              disabled={disabled}
              control={
                <Switch
                  size="small"
                  checked={checked}
                  onChange={e => setChecked(e.target.checked)}
                  data-cy={dataCy}
                  disabled={disabled}
                />
              }
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box>{menuItemLabel}</Box>
                  {matureness !== 'enabled' && (
                    <Box
                      width={12}
                      height={12}
                      borderRadius={12}
                      sx={{
                        backgroundColor,
                      }}
                    />
                  )}
                </Stack>
              }
            />
          </span>
        </Tooltip>
      </FormGroup>
    </MenuItem>
  )
}

export default MenuToggleWithMatureness
